import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { Divider, Skeleton } from "@mui/material";
import WishlistButton from "../../../Shared/WishlistButton";
import Checkout from "../../Checkout";
import { useQuery } from "react-query";
import { myQuestionsFn } from "../../../Services/UserAccount/MyQuestions";
import SearchModal from "../../../Shared/Search";

const MyQuestionsAnswer = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const { data: myQuestions, isLoading } = useQuery(
    ["myQuestions"],
    () => myQuestionsFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return (
    <>
      <div className="py-4 px-3 shadow h-16 fixed top-0 z-50 bg-white dark:bg-zinc-900 w-full flex justify-between gap-4">
        <span className="flex gap-5 items-center">
          <ArrowBack onClick={() => navigate(-1)} />
          <p className="text-xl">My Questions</p>
        </span>
        <span className="flex gap-5 items-center ">
          <SearchModal />
          <WishlistButton /> <Checkout />
        </span>
      </div>
      {myQuestions?.data?.faq_data === [] ? (
        <div className="flex h-[90vh] justify-center text-xl font-bold items-center">
          You haven't posted any question yet
        </div>
      ) : (
        <div className="flex flex-col gap-2 bg-zinc-200 dark:bg-zinc-700 min-h-screen py-[75px] px-2">
          {isLoading
            ? [1, 2, 3, 4, 5, 6].map(() => {
                return (
                  <div className="flex flex-col gap-1 rounded-lg shadow bg-white dark:bg-zinc-900 p-3">
                    <span className="flex gap-3 w-full">
                      <Skeleton className="w-16 !scale-100 !h-16" />
                      <Skeleton className="!h-4 !mt-1 !scale-100 w-2/3" />
                    </span>
                    <Skeleton />
                    <Skeleton />
                    <Skeleton className="w-1/2" />
                  </div>
                );
              })
            : myQuestions?.data?.faq_data?.map((faq) => {
                return (
                  <div className="flex flex-col gap-2 rounded-lg shadow bg-white dark:bg-zinc-900 p-3">
                    <span className="flex gap-3">
                      <img src={faq.variant_image} alt="" className="w-14" />
                      <p className="font-bold">{faq.variant_name}</p>
                    </span>
                    <Divider />
                    <p className="text-sm font-semibold"> Q: {faq.question}</p>
                    {faq?.answers?.length === 0 && (
                      <p className="text-xs font-semibold dark:text-zinc-300 text-zinc-600">
                        No answers received yet
                      </p>
                    )}
                  </div>
                );
              })}
        </div>
      )}
    </>
  );
};
export default MyQuestionsAnswer;
